import { lazy, Suspense } from "react";

import ModuleEmptyPage from "../components/emptyPage";
import BackHome from "../page/back/home";

const BackChangePassword = lazy(() => import("../page/back/password"));

const BackEnergyDetectUpdownStatistic = lazy(() =>
  import("../page/back/energyDetect/updownStatistic")
);
const BackEnergyDetectElectricityMeterTable = lazy(() =>
  import("../page/back/energyDetect/electricityMeterTable")
);
const BackEnergyDetectElectricityMeterBoard = lazy(() =>
  import("../page/back/energyDetect/electricityMeterBoard")
);

const BackEnergyUseDemandManage = lazy(() =>
  import("../page/back/energyUse/demandManage")
);
const BackEnergyOptimalContractCapacity = lazy(() =>
  import("../page/back/energyUse/optimalContractCapacity")
);
const BackEnergyUseMultiTargetCompare = lazy(() =>
  import("../page/back/energyUse/multiTargetCompare")
);
const BackEnergyUseMultiTimeCompare = lazy(() =>
  import("../page/back/energyUse/multiTimeCompare")
);
const BackEnergyUseUsageStatistic = lazy(() =>
  import("../page/back/energyUse/usageStatistic")
);
const BackEnergyUseFeeStatistic = lazy(() =>
  import("../page/back/energyUse/feeStatistic")
);
const BackEnergyBuildingCompare = lazy(() =>
  import("../page/back/energyUse/buildingCompare")
);
const BackEnergyAreaPerformance = lazy(() =>
  import("../page/back/energyUse/areaPerformance")
);
const BackEnergyUseUsageMQoMQ = lazy(() =>
  import("../page/back/energyUse/usageMQoMQ")
);
const BackEnergyUseGreenMQoMQ = lazy(() =>
  import("../page/back/energyUse/greenMQoMQ")
);
const BackEnergyUseFlowAnalysis = lazy(() =>
  import("../page/back/energyUse/flowAnalysis")
);
const BackEnergyUseUseAbnormality = lazy(() =>
  import("../page/back/energyUse/useAbnormality")
);
const BackEnergyUseUnitCostManage = lazy(() =>
  import("../page/back/energyUse/unitCostManage")
);

const BackHEMSMain = lazy(() => import("../page/back/hems"));
const BackHEMSOverview = lazy(() => import("../page/back/hems/overview"));
const BackHEMSUsageStatistic = lazy(() =>
  import("../page/back/hems/usageStatistic")
);

const BackSettingElectricityPrice = lazy(() =>
  import("../page/back/setting/electricityPrice")
);
const BackSettingControlDemand = lazy(() =>
  import("../page/back/setting/controlDemand")
);

const routeItems = [
  {
    path: "password",
    element: <BackChangePassword />,
  },

  {
    path: "energyDetect/updownStatistic",
    element: <BackEnergyDetectUpdownStatistic />,
  },
  {
    path: "energyDetect/electricityMeterTable",
    element: <BackEnergyDetectElectricityMeterTable />,
  },
  {
    path: "energyDetect/electricityMeterBoard",
    element: <BackEnergyDetectElectricityMeterBoard />,
  },

  {
    path: "energyUse/demandManage",
    element: <BackEnergyUseDemandManage />,
  },
  {
    path: "energyUse/optimalContractCapacity",
    element: <BackEnergyOptimalContractCapacity />,
  },
  {
    path: "energyUse/multiTargetCompare",
    element: <BackEnergyUseMultiTargetCompare />,
  },
  {
    path: "energyUse/multiTimeCompare",
    element: <BackEnergyUseMultiTimeCompare />,
  },
  {
    path: "energyUse/usageStatistic",
    element: <BackEnergyUseUsageStatistic />,
  },
  {
    path: "energyUse/feeStatistic",
    element: <BackEnergyUseFeeStatistic />,
  },
  {
    path: "energyUse/buildingCompare",
    element: <BackEnergyBuildingCompare />,
  },
  {
    path: "energyUse/areaPerformance",
    element: <BackEnergyAreaPerformance />,
  },
  {
    path: "energyUse/usageMQoMQ",
    element: <BackEnergyUseUsageMQoMQ />,
  },
  {
    path: "energyUse/greenMQoMQ",
    element: <BackEnergyUseGreenMQoMQ />,
  },
  {
    path: "energyUse/flowAnalysis",
    element: <BackEnergyUseFlowAnalysis />,
  },
  {
    path: "energyUse/useAbnormality",
    element: <BackEnergyUseUseAbnormality />,
  },
  {
    path: "energyUse/unitCostManage",
    element: <BackEnergyUseUnitCostManage />,
  },

  {
    path: "hems",
    element: <BackHEMSMain />,
  },
  {
    path: "hems/overview",
    element: <BackHEMSOverview />,
  },
  {
    path: "hems/usageStatistic",
    element: <BackHEMSUsageStatistic />,
  },

  {
    path: "setting/electricityPrice",
    element: <BackSettingElectricityPrice />,
  },
  {
    path: "setting/controlDemand",
    element: <BackSettingControlDemand />,
  },
];

const routes = [
  {
    path: "home",
    element: <BackHome />,
  },

  ...routeItems.map((item) => ({
    path: item.path,
    element: <Suspense>{item.element}</Suspense>,
  })),

  {
    path: "*",
    element: <ModuleEmptyPage />,
  },
];

export default {
  routes,
};
